<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>Academy Enrolment Revenue<span class="badge">{{ totalRecords }}</span></h4>
        </div>
        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>
        </div>
      </div>
      <div class="mainDivBody"> 
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadAERReports(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul>
          <div class="divider ">
            <hr>
          </div>
            <div class="filterTitle">
            <h5>Filters</h5>
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>Please select a Country first to view available States.</li>
              <li>Please select a State first to view available Cities.</li>
            </ul>
          </div>
           <div class="maincard">
            <div class="filterList">
              <ul>
                <li>
                <p-dropdown inputId="totalCoaches" [options]="countrylist" [filter]="true"
                  (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name"
                  appendTo="body" [showClear]="true" [(ngModel)]="country"></p-dropdown>
                </li>
              
                <li>
                   <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                  (onChange)="getCities($event)" placeholder="Select State" optionLabel="name"
                  appendTo="body" [showClear]="true" [(ngModel)]="state"></p-dropdown>
                </li>
                 <li>
               <p-dropdown inputId="totalCoaches" [options]="cityList" [filter]="true"
                  (onChange)="loadAERReports(lastTableLazyLoadEvent)" placeholder="Select City" optionLabel="name"
                  optionValue="name" appendTo="body" [showClear]="true" [(ngModel)]="cityName"></p-dropdown>
                </li>
                <li>
                    <p-dropdown inputId="totalCoaches" [options]="sportList" [filter]="true"
                  (onChange)="loadAERReports(lastTableLazyLoadEvent)" placeholder="Select Sport" optionLabel="name"
                  optionValue="name" appendTo="body" [showClear]="true" [(ngModel)]="sportName"></p-dropdown>
                </li>
                  <li>
             <p-dropdown inputId="totalCoaches" [options]="academiesList" [filter]="true"
                  (onChange)="loadAERReports(lastTableLazyLoadEvent)" placeholder="Select Academy" optionLabel="name"
                  optionValue="id" appendTo="body" [showClear]="true" [(ngModel)]="academyId"></p-dropdown>
                </li> 
              </ul>
            </div>
          </div>
           <div class="detailsList">
          <ul>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Number of Users</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{aerlist?.summary?.totalNumberOfUsers}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Enrolments Made</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{aerlist?.summary?.totalEnrolmentsMade}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Academies Enrolled</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{aerlist?.summary?.totalAcademiesEnrolled}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Coupon Amount (Venue)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{aerlist?.summary?.totalCouponAmountVenue}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Coupon Amount (TPL)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{aerlist?.summary?.totalCouponAmountTPL}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Commission</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{aerlist?.summary?.totalTPLCommission}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Academy Payout</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{aerlist?.summary?.totalAcademyPayout}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Share</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{aerlist?.summary?.totalTPLShare}}</h3>
                  </div>
              </div>
            </li> 
          </ul>
        </div>  
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="aerlist?.data" [autoLayout]="true" [paginator]="true" [rows]="10"
              [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadAERReports($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="mobileNumber">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon
                        field="mobileNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="username" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon field="username"></p-sortIcon>
                    </div>
                  </th>
                  <th class="enrolmentIdTD" pSortableColumn="enrolmentId">
                    <div class="p-d-flex p-jc-between p-ai-center"> EnrolmentID <p-sortIcon
                        field="enrolmentId"></p-sortIcon>
                    </div>
                  </th>
                  <th class="enrolmentDateTd" pSortableColumn="enrolmentDate">
                    <div class="p-d-flex p-jc-between p-ai-center"> Enrolment Date <p-sortIcon
                        field="enrolmentDate"></p-sortIcon>
                    </div>
                  </th>
                  <th class="CategoryTD" pSortableColumn="category"
                    [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> Category <p-sortIcon field="category"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BatchTD" pSortableColumn="batch">
                    <div class="p-d-flex p-jc-between p-ai-center"> Batch <p-sortIcon
                        field="batch"></p-sortIcon>
                    </div>
                  </th>
                  <th class="ageTd" pSortableColumn="age">
                    <div class="p-d-flex p-jc-between p-ai-center"> Age <p-sortIcon
                        field="age"></p-sortIcon>
                    </div>
                  </th>
                  <th class="DurationTD" pSortableColumn="duration">
                    <div class="p-d-flex p-jc-between p-ai-center"> Duration <p-sortIcon
                        field="duration"></p-sortIcon>
                    </div>
                  </th>
                  <th class="academyName" pSortableColumn="academyName" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Name <p-sortIcon
                        field="academyName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="academyStateTd " pSortableColumn="academyState" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy State <p-sortIcon
                        field="academyState"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="academyCity" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy City <p-sortIcon
                        field="academyCity"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="academyCountry" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Country <p-sortIcon
                        field="academyCountry"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="startDate" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Start Date <p-sortIcon
                        field="startDate"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="endDate" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> End Date <p-sortIcon
                        field="endDate"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponApplied" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Applied <p-sortIcon
                        field="couponApplied"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponDiscountAmountVenue" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Discount Amount (Venue) <p-sortIcon
                        field="couponDiscountAmountVenue"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponDiscountAmountTPL" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Discount Amount (TPL) <p-sortIcon
                        field="couponDiscountAmountTPL"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="academyFees" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Fees <p-sortIcon
                        field="academyFees"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplRevenue" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Revenue <p-sortIcon
                        field="tplRevenue"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="gstAmount" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> GST Amount <p-sortIcon
                        field="gstAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplCommissionPercent" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Commission % <p-sortIcon
                        field="tplCommissionPercent"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplCommissionAmount" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Commission Amount <p-sortIcon
                        field="tplCommissionAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="academyPayout" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Payout <p-sortIcon
                        field="academyPayout"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplShare" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Share <p-sortIcon
                        field="tplShare"></p-sortIcon>
                    </div>
                  </th>
                  <th class="sorting_disabled text-nowrap p-element action-button-td" rowspan="1"
                    colspan="1" style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>
                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap" style="left: 0px">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
                      [value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
                  </th>
                  <th class="userNameTD">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'username', 'contains')"
                      [value]="dt.filters['username'] ? dt.filters['username'].value : ''" />
                  </th>
                  <th class="enrolmentIdTD">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'enrolmentId', 'contains')"
                      [value]="dt.filters['enrolmentId'] ? dt.filters['enrolmentId'].value : ''" />
                  </th>
                  <th class="enrolmentDateTd">
                    <input pInputText type="date" (change)="setDownloadFlag(); dt.filter($event.target.value, 'enrolmentDate', 'equals')"
                      [value]="dt.filters['enrolmentDate'] ? dt.filters['enrolmentDate'].value : ''" />
                  </th>
                  <th class="CategoryTD" [ngClass]="hide ? 'hide-bank-small' : 'show-bank-small'">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'category', 'contains')"
                      [value]="dt.filters['category'] ? dt.filters['category'].value : ''" />
                  </th>
                  <th class="BatchTD">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'batch', 'contains')"
                      [value]="dt.filters['batch'] ? dt.filters['batch'].value : ''" />
                  </th>
                  <th class="ageTd">
                    <input pInputText type="number" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'age', 'equals')"
                      [value]="dt.filters['age'] ? dt.filters['age'].value : ''" />
                  </th>
                  <th class="DurationTD">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'duration', 'contains')"
                      [value]="dt.filters['duration'] ? dt.filters['duration'].value : ''" />
                  </th>
                  <th class="academyName" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
                      [value]="dt.filters['academyName'] ? dt.filters['academyName'].value : ''" />
                  </th>
                  <th class="academyStateTd" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyState', 'contains')"
                      [value]="dt.filters['academyState'] ? dt.filters['academyState'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyCity', 'contains')"
                      [value]="dt.filters['academyCity'] ? dt.filters['academyCity'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyCountry', 'contains')"
                      [value]="dt.filters['academyCountry'] ? dt.filters['academyCountry'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="date" (change)="setDownloadFlag(); dt.filter($event.target.value, 'startDate', 'equals')"
                      [value]="dt.filters['startDate'] ? dt.filters['startDate'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="date" (change)="setDownloadFlag(); dt.filter($event.target.value, 'endDate', 'equals')"
                      [value]="dt.filters['endDate'] ? dt.filters['endDate'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponApplied', 'contains')"
                      [value]="dt.filters['couponApplied'] ? dt.filters['couponApplied'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponDiscountAmountVenue', 'equals')"
                      [value]="dt.filters['couponDiscountAmountVenue'] ? dt.filters['couponDiscountAmountVenue'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponDiscountAmountTPL', 'equals')"
                      [value]="dt.filters['couponDiscountAmountTPL'] ? dt.filters['couponDiscountAmountTPL'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyFees', 'equals')"
                      [value]="dt.filters['academyFees'] ? dt.filters['academyFees'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplRevenue', 'equals')"
                      [value]="dt.filters['tplRevenue'] ? dt.filters['tplRevenue'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'gstAmount', 'equals')"
                      [value]="dt.filters['gstAmount'] ? dt.filters['gstAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplCommissionPercent', 'equals')"
                      [value]="dt.filters['tplCommissionPercent'] ? dt.filters['tplCommissionPercent'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplCommissionAmount', 'equals')"
                      [value]="dt.filters['tplCommissionAmount'] ? dt.filters['tplCommissionAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyPayout', 'equals')"
                      [value]="dt.filters['academyPayout'] ? dt.filters['academyPayout'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplShare', 'equals')"
                      [value]="dt.filters['tplShare'] ? dt.filters['tplShare'].value : ''" />
                  </th>
                  <th class="text-nowrap p-element action-button-td"  style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-aerlist>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="mobileNumberTD p-element text-nowrap">
                    <div class="textOverFlow1" pTooltip="	{{aerlist.mobileNumber}}" tooltipPosition="bottom">
                      {{aerlist.mobileNumber}}
                    </div>
                  </td>
                  <td class="userNameTD">
                    {{ aerlist.username }}
                  </td>
                   <td class="enrolmentIdTD">
                    {{ aerlist.enrolmentId }}
                  </td>
                  <td class="enrolmentDateTd">
                    {{ aerlist.enrolmentDate | date : "dd/MM/yyyy" }}
                  </td>
                  <td class="CategoryTD">
                    {{ aerlist.category}}
                  </td>
                  <td class="BatchTD">
                    {{ aerlist.batch }}
                  </td>
                  <td class="ageTd" >
                    {{ aerlist.age != null && aerlist.age !== undefined ? aerlist.age : '' }}
                  </td>
                  <td class="DurationTD">
                    {{ aerlist.duration == 1 ? '1 Month' : (aerlist.duration > 1 ? (aerlist.duration + ' Months') : '') }}
                  </td>
                  <td class="academyName" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.academyName }}
                  </td>
                  <td class="academyStateTd" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.academyState }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.academyCity }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.academyCountry }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.startDate | date : "dd/MM/yyyy" }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.endDate | date : "dd/MM/yyyy" }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.couponApplied || '-' }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.couponDiscountAmountVenue }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.couponDiscountAmountTPL }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.academyFees }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.tplRevenue }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.gstAmount }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.tplCommissionPercent }} %
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.tplCommissionAmount }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.academyPayout }}
                  </td>
                  <td class="BankDteailsTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ aerlist.tplShare }}
                  </td>
                  <td class="text-nowrap p-element action-button-td"></td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="25">Academy enrolment revenue list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
